import React, { useState, useEffect, useMemo, useRef } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEllipsisV,
  faPencil,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { hasPermission } from "../utils/usePermissions";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
const SecurityIn = ({ permissions }) => {
  const [searchInput, setSearchInput] = useState("");

  const navigate = useNavigate();
  const code = localStorage.getItem("code");
  const token = localStorage.getItem("token");
  const [securityIns, setSecurityIns] = useState([]);

  useEffect(() => {
    fetchSecurityIn();
  }, []);

  const fetchSecurityIn = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/getSecurityIn", {
        params: { code: code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setSecurityIns(response.data);
    } catch (error) {
      console.error("Error fetching Sewadars:", error);
    }
  };

  const handleEdit = (entry) => {
    navigate("../vehicleInPage", { state: { entry: entry } });
  };

  const handleDelete = async (row) => {
    const { id } = row; // Destructure the necessary fields from row.original

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this security in entry? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        const response = await apiClient.delete(
          SERVER_BASE + "/deleteSecurityIn",
          {
            data: { id, code },
            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
          }
        );

        fetchSecurityIn();

        Swal.fire({
          icon: "success",
          title: response.data.message,
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error deleting Entry:", error);
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.error,
          toast: true,
          position: "top-end",
          showConfirmButton: true,
        });
      }
    }
  };

  const columns = React.useMemo(
    () => [
      // {
      //   Header: 'S.No',
      //   Cell: ({ row }) => row.index + 1,
      // },
      {
        Header: "SR No",
        accessor: "gsrs",
        Cell: ({ value }) => `${value ? value : "-"}`, // Add '#SI-' prefix
      },
      {
        Header: "Date",
        accessor: "entryDate",
        Cell: ({ value }) =>
          `${value ? moment(value).format("DD-MMM-YY") : "-"}`, // Add '#SI-' prefix
      },
      { Header: "Vehicle", accessor: "vehicleNumber" },
      { Header: "Came From", accessor: "cameFrom" },
      {
        Header: "Item Group",
        accessor: "itemGroup",
        Cell: ({ value }) => (
          <ul>
            {value?.split("~").map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ),
      },
      // { Header: 'Purpose', accessor: 'purpose' },
      // {
      //   Header: 'Doc Status',
      //   accessor: 'documentStatus',
      //   Cell: ({ value }) => {
      //     const option = documentOptions.find((opt) => opt.value === value);
      //     return option ? option.label : value; // Show label if found, otherwise show raw value
      //   },
      // },
      // { Header: 'Doc #', accessor: 'documentNo' },
      // { Header: 'Doc Date', accessor: 'documentDate',
      //   Cell: ({ value }) => `${value ? moment(value).format('DD-MMM-YY') : '-'}`, },
      { Header: "Name", accessor: "driverName" },
      { Header: "Mobile", accessor: "mobileNo" },
      {
        Header: "SI No",
        accessor: "siCode",
        Cell: ({ value }) => `${value ? value : "-"}`, // Add '#SI-' prefix
      },
      {
        Header: "Action",
        Cell: ({ row }) => {
          return (
            <div className="dropdown">
              <button
                className="btn btn-light btn-sm"
                type="button"
                id={`dropdownMenuButton-${row.id}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>

              <ul
                className="dropdown-menu"
                aria-labelledby={`dropdownMenuButton-${row.id}`}
              >
                {permissions?.edit && (
                  <li>
                    <button
                      className="dropdown-item "
                      onClick={() => handleEdit(row.original)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                )}
                {permissions?.delete && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleDelete(row.original)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </button>
                  </li>
                )}
                <li>
                  <hr />
                </li>
                <li className="dropdown-item text-muted">
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {row.original.createdByName
                    ? `${row.original.createdByName} (${row.original.createdAt
                      ? moment(row.original.createdAt).format(
                        "DD-MMM-YY hh:mm A"
                      ) // 5*60 + 30 = 330
                      : ""
                    }) `
                    : "-"}
                </li>
                {row.original.updatedBy ? (
                  <li className="dropdown-item text-muted">
                    <FontAwesomeIcon icon={faPencil} />{" "}
                    {row.original.updatedByName
                      ? `${row.original.updatedByName} (${row.original.updatedAt
                        ? moment(row.original.updatedAt).format(
                          "DD-MMM-YY hh:mm A"
                        )
                        : ""
                      })`
                      : ""}
                  </li>
                ) : null}
              </ul>
            </div>
          );
        },
      },
    ],
    [securityIns, permissions]
  );

  const data = useMemo(() => {
    return securityIns.filter((row) => {
      const searchValue = searchInput.toLowerCase();
      return Object.values(row).some((value) =>
        value?.toString().toLowerCase().includes(searchValue)
      );
    });
  }, [securityIns, searchInput]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
    setPageSize,
    pageOptions,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <div className="formcontainer mt-5">
      <h3>Security In</h3>
      <div className="d-flex gap-2">
        {permissions?.write && (
          <button
            className="btn btn-outline-success"
            onClick={() => {
              navigate("../vehicleInPage");
            }}
          >
            Add Security In
          </button>
        )}
        {permissions?.read && (
          <>
            <input
              type="text"
              className="form-control w-75"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />

            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className="form-select form-select-sm"
              style={{ width: "auto" }}
            >
              {[10, 25, 50, 100, 200].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
      {permissions?.read && (
        <>
          <div className="table-responsive">
            <table
              {...getTableProps()}
              className="table table-striped mt-3"
              style={{ fontSize: "13px", verticalAlign: "baseline" }}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="pagination d-flex justify-content-between align-items-center">
            <button
              className="btn btn-secondary"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              Previous
            </button>
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SecurityIn;
